import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { doctrineAnalytics } from '../../../../../../utils/analyticsUtils';
import { getResetMessage } from '../../utils/constants';

import styles from './reset_query_message.module.scss';

type Props = {
  type: string;
  translationId: string;
  articleTitle: string;
  query: string;
  onResetQueryMessageClicked: () => {};
};

export const ResetQueryMessage: FC<Props> = ({
  type,
  translationId,
  articleTitle,
  query,
  onResetQueryMessageClicked,
}) => {
  return (
    <>
      <FormattedMessage
        id={translationId}
        values={{
          title: articleTitle,
          query,
          strong: (msg: string) => <strong>{msg}</strong>,
        }}
      />
      <span
        className={styles.resetLink}
        onClick={() => {
          doctrineAnalytics('Search DeleteQueryClicked');
          onResetQueryMessageClicked();
        }}
      >
        <FormattedMessage id={getResetMessage(type)} />
      </span>
    </>
  );
};
